<template>
  <div>
    <template v-if="project && !loading">
      <div class="p-ml-3 p-mb-0">
        <h1 class="p-mb-0">{{ isAdmin ? `${company.companyname} - `: '' }}{{ project.projectname }}</h1>
        <p class="subHeader">{{ project.address }}, {{ project.postalcode }} {{ project.postalplace }}</p>
      </div>
      <TabView class="p-pt-5">
        <TabPanel header="Containere">
          <containerList :project="project" :disabled="!project.active"/>
        </TabPanel>
        <TabPanel header="Tilganger">
          <projectUsers :project="project" :disabled="!project.active" />
        </TabPanel>
        <TabPanel v-if="project.active" header="Avslutt">
          <projectEnd :project="project"/> 
        </TabPanel>
      </TabView>
    </template>
  </div>
</template>

<script>

import projectEnd from '@/components/projects/projectEnd'
import containerList from '@/components/containers/containerList'
import projectUsers from '@/components/projects/projectUsers'

import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';



export default {
name: 'projectDetails',
components: {
  TabView,
  TabPanel,
  projectUsers,
  projectEnd,
  containerList,
},

data(){
  return{
    loading: false,
    showUsersDialog: false,
    showNewContainerDialog: false,
  }
},

mounted(){
  this.loading = true
  this.$store.dispatch('projects/inspect', {id: this.$route.params.id, type: 'project'}).then(() => {
    this.loading = false
  })
},


computed:{
  project(){
    return this.$store.getters["projects/inspect"]
  },
  company(){
    return this.$store.getters['companies/current']
  },
  isAdmin(){
    return this.$store.getters["user/isAdmin"]
  }
},
}
</script>


<style lang="sass">

.p-sidebar
  overflow-y: scroll

#projectDetails-dialog
  max-width: 90%
</style>